<template>
    <div>
        <div class="" style="margin-top: 47px;" ref="timelineReview">
            <spinner :data="spinnerData"></spinner>
            <all-feeds :feeds="feeds" :feed-status="feedsStatus" :feeds-count="fullFeedsCount" ></all-feeds>
        </div>
    </div>
</template>

<script>
    import allFeeds from "./allFeeds";
    import {mapState} from "vuex";
    export default {
        name: "timelineReview",
        components: {allFeeds},
        data() {
            return {
                feeds: [],
                spinnerData: {},
                feedsStatus: Boolean,
                next_page_url: '',
                last_page_url: '',
                first_page_url: '',
                current_page: '',
                last_page: '',
                fullFeedsCount: '',
            }
        },
        props: {
            signedIn: Boolean,
        },
        watch: {
            feeds(val) {
                // const re = JSON.stringify(val)
                // const er = JSON.parse(re)
                // for (let i = 0; i < val.length; i++) {
                //     this.mainData.push(val[i])
                // }


            },
        },
        computed: mapState({
            getUserDetails: state => state.user,
        }),
        created() {
            window.addEventListener('focus', this.showTweet);
            setInterval( this.showTweet, 50000 );
            this.getAllReviews();
        },
        mounted() {
            // this.getAllReviews();
            window.addEventListener('focus', this.showTweet);
            // check if there is a request to load feeds
            window.eventBus.$on("loadFeeds", val => {
                if(val === true) {
                    this.getAllReviews();
                }
            })
            window.eventBus.$on('loadMoreReview', val => {
                const $route = this.$route.name
                if($route === 'NewsFeed') {
                    if(val === true) {
                        const nextUrl = this.next_page_url
                        this.addReview(nextUrl);
                    }
                }
            })
            // console.log('props ',this.$props)
            this.showLoading();
            const vids = $("#video");
            $.each(vids, function(){
                this.controls = false;
            });
        },
        methods: {
            showTweet() {
                // this.getAllReviews
                const lastFeed = this.feeds ? this.feeds[0].created_at : null;
                if (lastFeed) {
                    this.axios.get(`/timeline/check_feeds/${lastFeed}`)
                        .then(response => {
                            // console.log(response.data.data.status)
                            const status = response.data.data.status;
                            if (status) {
                                window.eventBus.$emit('loadFeeds', true)
                                window.eventBus.$emit('newReview', true)
                                // this.getNewReviews()
                            }
                        })
                        .catch(error => {
                            return error
                            // console.log(error)
                        })
                }
            },
            showLoading(options = {}) {
                let loader = this.spinnerData = {
                    spinner: 'Jumper',
                    isLoading: options.show !== undefined ? options.show : true ,
                    color: '#00bfff',
                    size: '60px',
                    options: 'center relative',
                };
                return loader;
            },
            getNewReviews() {
                let userId = 0;
                if (this.getUserDetails.id) {
                    userId = this.getUserDetails.id;
                }
                this.axios
                    .get(`/timeline/reviews/all/${userId}/20`)
                    .then(response => {
                        var feeds = response.data.data.feeds.data;
                        this.feeds = []
                        this.feeds.unshift(...feeds);
                        this.fullFeedsCount = response.data.data.feeds_count;
                        if (feeds.length > 0) {
                            this.feedsStatus = true;
                        }else {
                            this.feedsStatus = false;
                        }
                        this.next_page_url = response.data.data.feeds.next_page_url;
                        this.last_page_url = response.data.data.feeds.last_page_url;
                        this.first_page_url = response.data.data.feeds.first_page_url;
                        this.current_page = response.data.data.feeds.from;
                        this.last_page = response.data.data.feeds.to;
                    })
            },
            getAllReviews() {
                this.showLoading({show: true})
                let userId = 0;
                if (this.getUserDetails.id) {
                    userId = this.getUserDetails.id;
                }
                this.axios
                    .get(`/timeline/reviews/all/${userId}/30`)
                    .then(response => {
                        this.showLoading({show:false})
                        var feeds = response.data.data.feeds.data;
                        this.feeds = []
                        this.feeds.push(...feeds);
                        this.fullFeedsCount = response.data.data.feeds.total;
                        if (feeds.length > 0) {
                            this.feedsStatus = true;
                        }else {
                            this.feedsStatus = false;
                        }
                        this.next_page_url = response.data.data.feeds.next_page_url;
                        this.last_page_url = response.data.data.feeds.last_page_url;
                        this.first_page_url = response.data.data.feeds.first_page_url;
                        this.current_page = response.data.data.feeds.from;
                        this.last_page = response.data.data.feeds.to;
                        this.addReview(response.data.data.feeds.next_page_url)
                    })
                    .catch(error => {
                        this.showLoading({show:false})
                        return error;
                        // console.log(error.response);
                    });
            },
            addReview(url) {
                let userId = 0;
                if (this.getUserDetails.id) {
                    userId = this.getUserDetails.id;
                }
                window.eventBus.$emit('loadingFeed',true);
                this.axios
                    .get(url)
                    .then(response => {
                        window.eventBus.$emit('loadingFeed',false);
                        this.showLoading({show:false})
                        var feeds = response.data.data.feeds.data;
                        this.feeds.push(...feeds);
                        this.fullFeedsCount = response.data.data.feeds_count;
                        this.next_page_url = response.data.data.feeds.next_page_url;
                        this.last_page_url = response.data.data.feeds.last_page_url;
                        this.first_page_url = response.data.data.feeds.first_page_url;
                        this.current_page = response.data.data.feeds.from;
                        this.last_page = response.data.data.feeds.to;
                    })
                    .catch(error => {
                        this.showLoading({show:false})
                        return error;
                        // console.log(error.response);
                    });
            }
        },
    }
</script>

<style scoped>

</style>
